export class MgHasher {
	private readonly data = Int32Array.of(0xA6C690FE, 0xCBF036C3, 0x9350889B, 0xE73A2BB5);

	private roll(x: number) {
		const data = this.data;
		data[0] += data[1] ^ x;
		data[1] ^= data[2] ^ (data[2]>>>13);
		data[2] += data[3] ^ x;
		data[3] ^= Math.imul(0x5765, data[0]);
		return this;
	}

	private mix() {
		const data = this.data;
		data[0] += data[1] ^ (data[1]>>7) ^ (data[1]>>12);
		data[1] ^= Math.imul(0x7563, data[2]);
		data[2] += data[3] ^ (data[3]>>9) ^ (data[3]>>11);
		data[3] ^= Math.imul(0x64CB, data[0]);
		return this;
	}

	private addStringInternal(x: string) {
		for (let i = 0; i < x.length; ++i) this.roll(x.codePointAt(i) as number);
		return this;
	}

	addString(x: string) {
		this.roll(0x4178A5F2);
		return this.addStringInternal(x);
	}

	addNumber(x: number) {
		const y = x | 0;
		if (x === y) return this.roll(0x77701234).roll(y);
		return this.roll(0xABCD0052).addStringInternal(x + '');
	}

	addArray(x: Array<any>) {
		this.roll(0xA55A10F0);
		for (let i=0; i<x.length; ++i) this.addAny(x[i]);
		return this;
	}

	private addHasherInternal(x: MgHasher) {
		const data = this.data;
		const delta = x.data;
		data[0] += delta[0];
		data[1] += delta[1];
		data[2] += delta[2];
		data[3] += delta[3];
	}

	addObject(x: {}) {
		this.roll(0x0B13C70A);
		Object.entries(x).forEach(([k, v]) => this.addHasherInternal(new MgHasher().addString(k).addAny(v).mix()));
		return this;
	}

	addUnordered(x: Array<any>) {
		this.roll(0x1103DE3ED);
		x.forEach(e => this.addHasherInternal(new MgHasher().addAny(e).mix()));
		return this;
	}

	addAny(x: any) {
		switch (typeof x) {
		case 'undefined':
			return this.roll(0x4FA8C472);
		case 'function':
			return this.roll(0xF114F136);
		case 'boolean':
			return this.roll(x ? 0x41578FB52 : 0xB845A25A0);
		case 'string':
			return this.addString(x);
		case 'symbol':
			return this.roll(0x555A5B5D).addStringInternal(x.toString());
		case 'number':
			return this.addNumber(x);
		case 'bigint':
			return this.roll(0xB1816677).addStringInternal(x + '');
		case 'object':
			if (!x) return this.roll(0x05110577);
			if (Array.isArray(x)) return this.addArray(x);
			return this.addObject(x);
		}
		return this;
	}

	toString() {
		const data = this.data;
		return [0, 1, 2, 3].map(i => (data[i]>>>0).toString(16).padStart(8, '0')).join('');
	}

	toInt32() {
		const data = this.data;
		const a = data[0] + data[1];
		const b = data[2] + data[3];
		return a ^ (b>>>16) ^ (b<<16);
	}

	toUint32() {
		return this.toInt32() >>> 0;
	}
}
